import { ACCESS_LEVEL } from "../../../../constants/types";

/**
 * @description Determine if read only
 * @param {boolean} isOffline - Determine if client is offline
 * @param {string} accessLevel - Determine if read only or write
 */
export const shouldBuilderBeReadOnly = ({ isOffline, accessLevel }) =>
  isOffline === true || accessLevel === ACCESS_LEVEL.READ_ONLY;